

import { useDispatch } from "react-redux"
import { actions } from "store"
import { AffliationRM } from "models/RM"
import { toastConfig } from "config"
import { toast } from "react-toastify"
import { application } from "store/hooks"
import { createAffiliationHooks } from ".."
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import { createAffiliationFetch } from "store/middlewares/affiliation.crud"
import { initialize, reset } from "redux-form"
import { getUserDataFetch } from "store/middlewares/user.crud"
import { secretStorage } from "config"
import qc from "keys/queryClient"

const useCreateAffiliation = (props) => {
    const { successMessage, errorMessage } = props || {}
    const dispatch = useDispatch()
    const setAlert = createAffiliationHooks.useAlert()
    const queryClient = useQueryClient()
    const setAppData = application.useSetAppData()

    const userData = useQuery({
        queryKey: [qc.userData],
        queryFn: async () => {
            const { data } = await getUserDataFetch()
            const user = secretStorage.getItem("user")
            secretStorage.setItem("user", { ...user, user_data: data })
            setAppData(data)
            return data
        },
        enabled: false
    })

    const { mutateAsync: addAffiliation } = useMutation({
        mutationFn: createAffiliationFetch,
        onSuccess: ({ data }) => {
            userData.refetch()
            dispatch(reset("createAffliation"))
            dispatch(initialize('createAffliation', {}));
            queryClient.invalidateQueries({ queryKey: [qc.affiliationData], exact: false, })
            toast(successMessage || " היחידה נוצרה בהצלחה ", toastConfig)
            return data
        },
        onError: ({ response }) => {
            if (response?.data?.institution_code?.includes('duplicate institution code'))
                toast.error("קוד מוסד קיים במערכת, אנא בחר קוד מוסד אחר", toastConfig)
            else toast.error(errorMessage || "ישנה בעייה בעדכון היחידה", toastConfig)
        }
    })

    const createAffiliation = async (values) => {
        const affiliation = new AffliationRM(values)
        const affiliationInstance = await addAffiliation(affiliation)
        setAlert(false)
        return affiliationInstance
    }

    return createAffiliation
}

export default useCreateAffiliation